import store from '@/store';
import { getById } from '@/services/supervisor-service';
import NewChatvisorEvent from './NewChatvisorEvent';

// evento nova mensagem chatvisor
export default class NewChatvisorMessageEvent {
  constructor(messageEvent) {
    console.log('[NewChatvisorMessageEvent]', messageEvent);
    const {
      body: message,
      body: { from: supervisorId, to: agentId },
    } = messageEvent;

    const chatvisorUser = `${agentId}@${supervisorId}`;
    const { chats } = store.state.chatVisor;
    const existChatVisor =
      chats.findIndex(
        (chatVisor) => chatVisor.chatvisorUser === chatvisorUser,
      ) > -1;

    if (existChatVisor) {
      return this.alreadyExistsChatVisor(message, supervisorId);
    }

    this.doesNotExistChatVisor({ chatvisorUser, supervisorId }, message);
  }

  alreadyExistsChatVisor(message, supervisorId) {
    store.dispatch('chatVisor/newMessageChatvisor', { message, supervisorId });
  }

  async doesNotExistChatVisor({ chatvisorUser, supervisorId }, message) {
    try {
      const supervisor = await getById(supervisorId);

      const bodyFakeEvent = {
        supervisorId,
        chatvisorUser,
        supervisorName: supervisor.name,
      };

      new NewChatvisorEvent(bodyFakeEvent);

      this.alreadyExistsChatVisor(message, supervisorId);
    } catch (err) {
      console.error(err);
    }
  }
}
